import React from 'react';

import OptimizedRouteTable from '../components/delivery-page/optimizedRouteTable';

class OptimizedRoute extends React.Component{
	constructor(props){
		super(props);
	}
	render(){
		
		const { id } = this.props.match.params;
		return (
			<div>
				<OptimizedRouteTable 
				routeId = {id}
				/>
			</div>
		)
	}

}

export default OptimizedRoute;


// WEBPACK FOOTER //
// ./src/containers/optimizedRoute.js